import React from "react";
import { ToastContainer } from "react-toastify";
import { ManageSubSectionsContent } from "../components/NewsManagement/SubSections/ManageSubSectionsContent";

export const ManageSubSections = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageSubSectionsContent />
        </div>
      </div>
    </div>
  );
};
